"use client";

import React from "react";
import { Card } from "@/components/ui/card";
export default function CommercialAlliances() {
  const alliances = [{
    id: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.50.01-p.m-2.png?v=v8y0at1oexj",
    alt: "Socio Comercial 1"
  }, {
    id: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.50.04-p.m-2.png?v=qiqyauxrt5p",
    alt: "Socio Comercial 2"
  }, {
    id: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.50.07-p.m-2.png?v=s05425nz52f",
    alt: "Socio Comercial 3"
  }, {
    id: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.50.10-p.m-2.png?v=5suyaq899rg",
    alt: "Socio Comercial 4"
  }, {
    id: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.50.13-p.m-2.png?v=tgtjzif470i",
    alt: "Socio Comercial 5"
  }, {
    id: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.47.25-p.m.png?v=5kysg1x41h5",
    alt: "Socio Comercial 6"
  }, {
    id: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.47.33-p.m.png?v=ikg5lqo8hiq",
    alt: "Socio Comercial 7"
  }, {
    id: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.47.43-p.m.png?v=8zx4d5brqim",
    alt: "Socio Comercial 8"
  }, {
    id: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.47.37-p.m.png?v=s91x85vd1rp",
    alt: "Socio Comercial 9"
  }, {
    id: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.49.35-p.m.png",
    alt: "Socio Comercial 10"
  }];
  return <section id="commercial-alliances" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-default font-bold text-foreground mb-4">
            Alianzas Comerciales
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            Trabajamos de la mano con las mejores empresas del sector para ofrecer soluciones integrales y de la más alta calidad.
          </p>
        </div>

        <div className="max-w-6xl mx-auto bg-white">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {alliances.map((alliance, i) => <Card key={alliance.id} data-index={i} className="p-6 flex items-center justify-center border border-border/50 rounded-lg hover:scale-105 transition-transform duration-300 hover:shadow-md bg-white">
                <img src={alliance.id} data-wvc-srcset={`${alliance.id}-wvc-srcset`} data-wvc-sizes={`${alliance.id}-wvc-sizes`} alt={alliance.alt} className="max-h-12 w-auto grayscale hover:grayscale-0 transition-all duration-300 object-contain" loading="lazy" decoding="async" />
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}